import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  noData: {
    textAlign: 'center',
  },
}));

export default useStyles;
